import { type UseQueryResult, useQuery } from 'react-query';
import {
  VestingTemplateService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_VestingTemplateForListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetVestingTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // vestingTypeIds?: string[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_VestingTemplateForListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, vestingTypeIds, _force } = tableInfo;
  const vestingTemplateList = useQuery(
    ['getVestingTemplateList', filter, sorting, skipCount, maxResultCount, vestingTypeIds, _force],
    async () => {
      return await handleRequest(
        VestingTemplateService.getApiAwardApiAppVestingTemplateVestingTemplateList(
          vestingTypeIds,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return vestingTemplateList;
};

export default useGetVestingTemplateList;
